import { useSEO } from "@/hooks/useSEO";
import { ComingSoon } from "@/components/ComingSoon";
import { useLanguage } from "@/context/LanguageContext";

export default function Voice() {
  const { t } = useLanguage();
  useSEO(
    t("nav.voice") + " — Diamotims Agency",
    "Voice-over artists for commercial, animation, games and narration — division opening soon at Diamotims Agency, Montréal."
  );
  return <ComingSoon eyebrow={t("voice.eyebrow")} pageTestid="voice-page" />;
}
